import script from "./SchemaDataset.vue?vue&type=script&setup=true&lang=js"
export * from "./SchemaDataset.vue?vue&type=script&setup=true&lang=js"

import "./SchemaDataset.vue?vue&type=style&index=0&id=786164ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-786164ec"]])

export default __exports__